(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('analyticsSecurityEvents', ["path", "$q", "columnsHelper", "securityEventsDao", "securityEventTypes", "tablePaginationHelper", "defaultListConverter", "securityEventsConverters", "objectTypeDao", "routeHelper", "base64", function (path, $q, columnsHelper, securityEventsDao, securityEventTypes, tablePaginationHelper, defaultListConverter, securityEventsConverters, objectTypeDao, routeHelper, base64) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('analytics/analytics-security-events').template('analytics-security-events'),
            scope: { saas: '=analyticsSecurityEvents' },
            link: function ($scope, element, attrs) {
                $scope.uuid = $scope.saas + '6f94704f-cf3c-4fe6-ab03-7fbabac2193d';
                $scope.filters = {
                    uuid: $scope.uuid,
                    iconClass: 'fa fa-filter',
                    filters: _(securityEventTypes.data()).map(function (type) {
                        return {
                            text: type.label,
                            value: type.id,
                            type: 'flag',
                            state: true
                        };
                    })
                };
                var filterStates = [
                    'new',
                    'remediated'
                ];
                $scope.options = {
                    'columns': [
                        {
                            'id': 'id',
                            'hidden': true,
                            'primary': true
                        },
                        {
                            'id': 'create_time',
                            'text': 'Time',
                            format: 'time',
                            'sortable': true
                        },
                        {
                            'id': 'current_state',
                            'text': 'State',
                            'converter': 'stateConverter'
                        },
                        {
                            'id': 'severity',
                            'text': 'Severity',
                            'dataClass': 'text-align-center',
                            'converter': 'severityConverter',
                            'sortable': true
                        },
                        {
                            'id': 'type',
                            'text': 'Type',
                            'converter': 'securityEventTypeConverter'
                        },
                        {
                            'id': 'description',
                            'text': 'Event Description',
                            'class': 'wide-column',
                            'dataClass': 'wide-column',
                            'converter': 'descriptionConverter'
                        },
                        {
                            'id': '_resolved.history',
                            'text': 'History',
                            'converter': 'multiConverter',
                            'converterArgs': {
                                'converters': [
                                    {
                                        'converter': 'historyArrayConverter',
                                        'converterArgs': {
                                            'field': 'create_time',
                                            'reverse': true
                                        }
                                    },
                                    {
                                        'converter': 'listConverter',
                                        'converterArgs': {
                                            'countPostfix': 'actions',
                                            'collapseRest': true,
                                            'moreInPopup': true,
                                            'expanded': 4,
                                            'itemConverter': 'historyItemConverter',
                                            'itemConverterScope': 'element'
                                        }
                                    }
                                ]
                            }
                        },
                        {
                            'id': '_resolved',
                            'hidden': true
                        },
                        {
                            'id': 'entity_id',
                            'hidden': true
                        },
                        {
                            'id': 'entity_type',
                            'hidden': true
                        },
                        {
                            'id': 'event_metadata',
                            'hidden': true
                        }
                    ],
                    'options': {
                        'defaultOrdering': {
                            'columnName': 'create_time',
                            'order': 'desc'
                        },
                        'autoUpdate': 60000,
                        lineSelection: true,
                        singleSelection: true
                    }
                };
                $scope.tableOptions = {
                    disableTop: true,
                    orderDisplayMode: 'highlight-column',
                    asDivs: true,
                    infinite: true,
                    reloadUuid: true,
                    showWorkingIndicator: false,
                    workingIndicatorDisableGui: false,
                    saveState: true,
                    pagesAround: 2,
                    pagination: {
                        pageSize: 20,
                        ordering: {}
                    },
                    dropdownHeader: true
                };
                $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                    var result = securityEventsDao.list().preFetch(objectTypeDao.entities(), 'objectTypes').params({ resolve: true }).params({
                        filterEnum_saas: $scope.saas,
                        filterEnum_type: _($scope.filters.filters).chain().map(function (filter) {
                            if (filter.state) {
                                return filter.value;
                            }
                        }).compact().value().join(',') || 'shownoevents',
                        filterEnum_current_state: filterStates.join(',')
                    });
                    return result.pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order).converter(defaultListConverter, function (preFetches) {
                        return {
                            columns: _($scope.options.columns).map(function (column) {
                                if (column.converter == 'descriptionConverter') {
                                    column.converterArgs = column.converterArgs || {};
                                    column.converterArgs.objectTypes = preFetches.objectTypes;
                                }
                                return column;
                            }),
                            converters: securityEventsConverters
                        };
                    });
                }, function (tableModel) {
                    $scope.tableModel = tableModel;
                    $scope.totalEvents = $scope.tableHelper.getTotal();
                });
                $scope.$watch('filters.filters', function (newVal, oldVal) {
                    $scope.tableHelper.reload();
                }, true);
                function addTitle(event) {
                    if (event.currentTarget.offsetWidth < event.currentTarget.scrollWidth) {
                        if (!event.currentTarget.getAttribute('title')) {
                            event.currentTarget.setAttribute('title', event.currentTarget.textContent);
                        }
                    }
                }
                $(document).on('mouseenter', '.security-events-tip-value', addTitle);
                $scope.$on('$destroy', function () {
                    $(document).off('mouseenter', '.security-events-tip-value', addTitle);
                });
                $scope.$watchCollection(function () {
                    return $scope.tableHelper ? $scope.tableHelper.getSelectedIds() : [];
                }, function (newValue) {
                    if (newValue && newValue.length === 1) {
                        $scope.tableHelper.clearSelection();
                        routeHelper.redirectTo('security-events', {}, {
                            qs: {
                                eventId: newValue[0],
                                filters: base64.encode(JSON.stringify({
                                    resolution: 'all',
                                    filters: _(filterStates).map(function (state) {
                                        return {
                                            type: 'current_state',
                                            id: state
                                        };
                                    }).concat(_($scope.filters.filters).chain().map(function (filter) {
                                        if (filter.state) {
                                            return {
                                                type: 'type',
                                                id: filter.value
                                            };
                                        }
                                    }).compact().value()).concat([{
                                            type: 'saas',
                                            id: $scope.saas
                                        }])
                                }))
                            }
                        });
                    }
                });
            }
        };
    }]);
}());